import { LOAD_LESSONS, LOAD_LESSON_DETAILS, SAVE_LESSON_INTEREST } from '../../constant';

const initialState = {
  data: [],
  listing: {},
  details: {},
  lockedCategories: [],
  interestedCategoryIds: [],
};

const lessons = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_LESSONS:
      return {
        ...state,
        ...action.payload,
      };
    case LOAD_LESSON_DETAILS:
      return {
        ...state,
        details: action.payload,
      };
    case SAVE_LESSON_INTEREST:
      return {
        ...state,
        interestedCategoryIds: action.payload,
      };
    default:
      return state;
  }
};

export default lessons;
